module.exports = __webpack_public_path__ + "static/media/about.99831439.jpg";